import { render, staticRenderFns } from "./TabCustomer.vue?vue&type=template&id=2e092106"
import script from "./TabCustomer.vue?vue&type=script&lang=js"
export * from "./TabCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports